import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { darkGrey } from '../../styles/constants';

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  color: ${darkGrey}
`;

const InfoToolTip = ({ text }) => (
  <OverlayTrigger
    placement="top"
    overlay={(
      <Tooltip id="tooltip-top">
        {text}
      </Tooltip>
      )}
  >
    <StyledFontAwesomeIcon
      icon="info-circle"
      className="ml-1"
    />
  </OverlayTrigger>
);

InfoToolTip.propTypes = {
  text: PropTypes.string.isRequired,
};

export default InfoToolTip;
